import CryptoJS from "crypto-js";

export const answerEncryptText = (text) => {
  const passphrase = window.ENV.HASH_SECRET_KEY;
  const combined = passphrase + text;
  // console.log(
  //   "answer hasing",
  //   CryptoJS.MD5(combined).toString(CryptoJS.enc.Hex)
  // );
  return CryptoJS.MD5(combined).toString(CryptoJS.enc.Hex);
};

export const answers_index_hashed_keys = (text) => {
  const combined = text;

  return CryptoJS.MD5(combined).toString(CryptoJS.enc.Hex);
};
